export const CATEGORY_TO_TITLE = {
	now_playing: '현재 상영작',
	popular: '인기 있는',
	top_rated: '평점순',
	upcoming: '개봉 예정작',
}
